import React from 'react';

const Login = () => {
    return (
        <div>
            This is Log In. 
        </div>
    );
};

export default Login;